import { connect } from 'react-redux';

import { getCoworkingOperator } from 'shared/store/coworking/selectors/dump/getCoworkingOperator';

import { IApplicationState } from '../../types/redux';
import { getCoworkingAccessInfo } from '../../utils/formatters';

import { ContactModal as ContactModalComponent } from './ContactModal';

export const mapState = (state: IApplicationState) => ({
  operator: getCoworkingOperator(state),
  accessInfo: getCoworkingAccessInfo(state.coworking?.worktime),
});

export const ContactModal = connect(mapState)(ContactModalComponent);
